const content = {
    USER_NAME: 'Welcome, Nikita',
};

export default content;